export interface IDmsSearchFilter {
    name?: string,
    identificationCode?: string,
    sapId?: string,
    type?: string,
    category?: string,
    currentStatus?: string | null,
    currentAttribute?: string | null,
    region?: string,
    province?: string,
    city?: string,
    address?: string,
    streetNumber?: string,
    chargingStationIdentificationCode?: string,
    chargingStationStatus?: string | null,
    chargingColumnId?: string,
    certificationProtocolIdentifyingCode?: string,
    isKeyless?: boolean
}

export enum IApplicationTabs {
    APPLICATION_DETAIL,
    DOCUMENTATION,
}